import {filter, findWhere, map, reject, some} from "underscore";

export const EXERCISE_TYPE_NAME = "Exercise";

export const isExercise = (incident) => {
  if (!incident) {
    return false;
  }

  return some(incident?.types, (incidentType) => {
    return incidentType?.type?.name === EXERCISE_TYPE_NAME;
  });
};

const getUserRoles = (user) =>
  map(
    reject(user.roles, (role) => role.isDeleted || role.role.isDeleted || !role.role.isEnabled),
    ({role}) => role,
  );

export const isAccessUser = (incident, user) => {
  const users = reject(
    incident.users,
    (incidentUser) =>
      incidentUser.isDeleted ||
      incidentUser.hasLeadershipChatAccess ||
      incidentUser.omittedFromIncidentChat ||
      incidentUser.hasScratchPadAccess,
  );

  if (some(users, ({userId}) => userId === user.id)) {
    return true;
  }

  return some(getUserRoles(user), (userRole) => isAccessRole(incident, userRole));
};

export const isAccessRole = (incident, role) =>
  some(
    incident.roles,
    (incidentRole) =>
      !incidentRole.isDeleted &&
      !incidentRole.hasLeadershipChatAccess &&
      !incidentRole.omittedFromIncidentChat &&
      !incidentRole.hasScratchPadAccess &&
      incidentRole.roleId === role.id,
  );

export const isLeadershipChatUser = (incident, user) => {
  const leadershipChat = some(
    incident.users,
    (incidentUser) =>
      !incidentUser.isDeleted &&
      incidentUser.userId === user.id &&
      incidentUser.hasLeadershipChatAccess,
  );

  if (leadershipChat) {
    return true;
  }

  return some(getUserRoles(user), (userRole) => isLeadershipChatRole(incident, userRole));
};

export const isLeadershipChatRole = (incident, role) => {
  return some(
    incident.roles,
    (incidentRole) =>
      !incidentRole.isDeleted &&
      incidentRole.hasLeadershipChatAccess &&
      incidentRole.roleId === role.id,
  );
};

export const isOmittedIncidentChatUser = (incident, user) => {
  const omittedIncidentChat = some(
    incident.users,
    (incidentUser) =>
      !incidentUser.isDeleted &&
      incidentUser.userId === user.id &&
      incidentUser.omittedFromIncidentChat,
  );

  if (omittedIncidentChat) {
    return true;
  }

  return some(getUserRoles(user), (userRole) => isOmittedIncidentChatRole(incident, userRole));
};

export const isOmittedIncidentChatRole = (incident, role) => {
  return some(
    incident.roles,
    (incidentRole) =>
      !incidentRole.isDeleted &&
      incidentRole.omittedFromIncidentChat &&
      incidentRole.roleId === role.id,
  );
};

export const isLeadUser = (incident, user) =>
  !!incident?.leadUser && incident.leadUser.id === user?.id;

export const isLeadUserOrHasNone = (incident, user) =>
  (incident && !incident.leadUser) || isLeadUser(incident, user);

export const getExerciseType = (types) => {
  return findWhere(types, {name: EXERCISE_TYPE_NAME});
};

export const filterOutExerciseType = (types) => {
  return filter(types, (type) => type.name !== EXERCISE_TYPE_NAME);
};

export const getIncidentBasePath = (incident) => {
  return isExercise(incident) ? "exercises" : "incidents";
};

export const getIncidentSubject = (incident) => (isExercise(incident) ? "Exercise" : "Incident");
